import { getImpersonator, getTokenSilently } from '../auth0'

export const getAuthHeaders = async (): Promise<HeadersInit | undefined> => {
  const impersonator = getImpersonator()

  if (impersonator) {
    return
  }

  const token = await getTokenSilently()
  return {
    Authorization: token || ''
  }
}
